import { Routes, Route } from "react-router-dom";
import MerchantsList from "./MerchantsList";
import MerchantDetail from "./MerchantDetail";

export default function DashboardRoutes() {
  return (
    <Routes>
      <Route index element={<MerchantsList />} />        {/* /dashboard */}
      <Route path=":id" element={<MerchantDetail />} />  {/* /dashboard/:id */}
    </Routes>
  );
}

